<template>
  <div class="flex w-full items-center justify-center mb-4 justify-center" v-if="showcaseProducts && loaded">
    <splide
      :options="options"
      class="w-2/3"
    >
      <splide-slide v-for="slide in showcaseProducts" :key="slide.id" class="relative">
        <img :src="getImage(slide, imageHeight)" alt="slide.name" :height="imageHeight * 1.3">
        <div class="relative w-full h-full">
          <div class="absolute bottom-0 w-full h-32 mb-4">
            <div class="w-5/6 p-2 bg-warning text-primary text-xs sm:text-sm" v-if="slide.onSale">
              <b>OFERTA ESPECIAL</b>
            </div>
            <div class="w-5/6 p-2 text-primary text-sm" v-else>&nbsp;</div>
          </div>
          <div class="absolute bottom-0 w-full mb-3">
            <div class="flex items-center justify-center w-full p-2 text-md sm:text-lg text-white text-center h-16">
              <span>{{ slide.name }}</span>
            </div>
            <div class="w-full text-center text-white">
              <span class="text-lg line-through mr-4" v-if="slide.onSale">Q{{ slide.originalPrice.toFixed(2) }}</span><span class="text-2xl"><b>Q{{ slide.price.toFixed(2) }}</b></span>
            </div>
          </div>
        </div>
      </splide-slide>
    </splide>
  </div>
</template>

<script>
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export default {
  data() {
    return {
      loaded: false,
      options: {
        type: 'loop',
        width: 260,
        height: 300 * 1.3,
        autoplay: true,
        interval: 10000,
        pauseOnHover: true,
        rewind: true,
        speed: 3000,
        gap: '1rem',
        perPage: 1,
        cover: true,
        heightRatio: 0.5,
        pagination: false,
        breakpoints: {
          320: {
            gap: '1rem',
            perPage: 1,
            width: 240
          },
          420: {
            gap: '1rem',
            perPage: 1,
            width: 370
          },
          570: {
            gap: '1rem',
            perPage: 1,
            width: 440
          },
          768: {
            gap: '1rem',
            perPage: 2,
            width: 560
          },
          960: {
            gap: '1rem',
            perPage: 2,
            width: 740
          },
          1024: {
            gap: '1rem',
            perPage: 2,
            width: 960
          },
          9999: {
            gap: '1rem',
            perPage: 3,
            width: 1300
          }
        }
      },
    }
  },
  computed: {
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    imageHeight() {
      if (this.windowWidth < 400) {
        return 300;
      } else if (this.windowWidth < 600) {
        return 300;
      } else {
        return 300;
      }
    },
    imagesURL() {
      return this.$store.getters['getParameter']('images').baseURL;
    },
    showcaseProducts() {
      return [...this.$store.getters.showcaseProducts].sort(function (a, b) {
        var ret = 1;
        if (a.sequence < b.sequence) {
          ret = -1;
        }
        return ret;
      });
    },
    showcaseProducts1() {
      if (this.$store.state.showcaseProducts) {
        if (this.$store.state.showcaseProducts.list) {
          return [...this.$store.state.showcaseProducts.list].sort(function (a, b) {
            var ret = 1;
            if (a.sequence < b.sequence) {
              ret = -1;
            }
            return ret;
          });
        } else {
          return [];
        }
      } else {
        return [];
      }
    }
  },
  watch: {
    // call again the method if the route changes
    'window.innerWidth': function () {
      console.log(this.windowWidth);
    }
  },
  methods: {
    getImage(item, height) {
      const image = item.imageURL.split('.');
      const imageURL = [this.imagesURL, '/showcase%2F', image[0], '@', height, '.', image[1], '?alt=media'].join('');
      return imageURL;
    }
  },
  mounted() {
    var self = this;
    setTimeout(function () {
      self.loaded = true;
    }, 500);
  }
}

</script>
